// extracted by mini-css-extract-plugin
module.exports = {"postThumbnail":"cf_m9","postThumbnail__image":"cf_nb","postThumbnail_gradient_bottom":"cf_nc","postThumbnail_gradient_left":"cf_nd","postThumbnail_gradient_right":"cf_nf"};